import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { getEmail, getEmailDetail, deleteEmail } from './APIs/email';
import types from '../constants/emailConstants';
import {
  getEmailAction,
  setEmailAction,
  setEmailDetailAction,
  setEmailDetailErrorAction,
} from '../actions/emailActions';
import { getApiErrorMessage } from 'utils/apiError';
import { successNotif, failedNotif } from '../actions/notifActions';

function* getEmailSaga({ payload }) {
  try {
    const data = yield getEmail(payload);
    yield put(setEmailAction(data));
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load invitations.')));
  }
}

function* deleteEmailSaga({ payload }) {
  const id = payload?.id ?? payload;
  const listQuery = payload?.listQuery;
  try {
    yield deleteEmail(id);
    yield put(successNotif('Delete Success'));
    const storedQuery = yield select((state) => state.getIn(['email', 'lastListQuery']));
    const refreshQuery = listQuery || (storedQuery ? storedQuery.toJS() : null);
    if (refreshQuery) {
      yield put(getEmailAction(refreshQuery));
    }
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to delete invitation.')));
  }
}

function* getEmailDetailSaga({ payload }) {
  try {
    const data = yield getEmailDetail(payload);
    yield put(setEmailDetailAction(data));
  } catch (error) {
    yield put(setEmailDetailErrorAction());
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load email detail.')));
  }
}

function* onGetEmail() {
  yield takeLatest(types.GET_EMAIL, getEmailSaga);
}

function* onDeleteEmail() {
  yield takeLatest(types.DEL_EMAIL, deleteEmailSaga);
}

function* onGetEmailDetail() {
  yield takeLatest(types.GET_EMAIL_DETAIL, getEmailDetailSaga);
}

export default function* emailSaga() {
  yield all([call(onGetEmail), call(onDeleteEmail), call(onGetEmailDetail)]);
}
